import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";

import { forwardRef, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "react-multi-carousel/lib/styles.css";
import api from "services/api";
import { saveAs } from "file-saver";

import colors from "assets/theme/base/colors";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import qs from "query-string";

import SuiBadgeDot from "components/SuiBadgeDot";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import DownloadIcon from "@mui/icons-material/Download";

import { socket } from "services/request";
import UnionwearLayout from "pages/unionwear/layout";

import JSZip from "jszip";
import FileSaver from "file-saver";
import ProjectResultItem from "./ProjectResultItem";

const ProjectDetailPage = () => {
  const [projectData, setProjectData] = useState(null);
  const [allVisibleToggle, setAllVisibleToggle] = useState(false);

  const pathnames = window.location.pathname.split("/");
  let uwproject_id = null;
  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "tasks") {
    uwproject_id = pathnames[pathnames.length - 1];
  }

  let resultData = projectData?.products?.ai_result || [];
  let productData = projectData?.products?.data || [];

  let images = [];

  for (let i = 0; i < resultData.length; i++) {
    let rd_images = resultData[i]?.images || [];
    for (let j = 0; j < rd_images.length; j++) {
      images.push({
        src: rd_images[j],
        code: resultData[i]?.task_meta?.code,
        product_id: resultData[i]?.task_meta?.product_id,
        viewpoint: resultData[i]?.task_meta?.viewpoint,
      });
    }
  }

  const navigate = useNavigate();

  useEffect(() => {
    if (uwproject_id) {
      retrieveProject(uwproject_id);
    }
  }, [uwproject_id]);

  useEffect(() => {
    if (uwproject_id) {
      //let delayDebounceFn;
      console.log("add socket");

      socket.on(`unionwear-task:update`, () => {
        retrieveProject(uwproject_id);

        console.log("trigger task update");
      });
      socket.on(`unionwear-task:update-status`, () => {
        retrieveProject(uwproject_id);

        console.log("trigger task update2");
      });
    }
  }, [uwproject_id]);

  const retrieveProject = async (id) => {
    try {
      const { data } = await api.uwProject.retrieve(id);
      let project = data?.uProject;
      setProjectData(project);
    } catch (err) {
      console.log(err);
      toast.error("Failed to retrieve project list!");
    }
  };

  const resultMap = {};
  for (let i = 0; i < resultData.length; i++) {
    let productId = resultData[i]?.task_meta?.product_id;
    if (resultMap?.[productId]) {
      resultMap[productId].push(resultData[i]);
    } else {
      resultMap[productId] = [resultData[i]];
    }
  }

  const handleDownloadUrls = (items) => {
    const zip = new JSZip();
    const promises = []; //用于存储多个promise

    const AllImageUrls = images.map((x) => x.src);
    const imageSet = new Set(AllImageUrls);
    items = items.filter((x) => imageSet.has(x.src));

    if (items.length == 1) {
      let fileName = items[0].code + ".png";
      if (items[0].viewpoint) {
        fileName = items[0].code + "_" + items[0].viewpoint.toUpperCase() + ".png";
      }

      saveAs(items[0].src, fileName);
      return;
    }

    let image_count = {};

    items.forEach((item) => {
      const promise = getFile(item.src).then((res) => {
        let fileName = item.code;
        if (item.viewpoint) {
          fileName = item.code + "_" + item.viewpoint;
        }
        fileName = fileName.toUpperCase();

        if (image_count[fileName]) {
          image_count[fileName] = image_count[fileName] + 1;
        } else {
          image_count[fileName] = 1;
        }
        if (image_count[fileName] > 1) {
          fileName = fileName + "_" + (image_count[fileName] - 1);
        }

        zip.file(fileName + ".png", res, { binary: true });
      });
      promises.push(promise);
    });

    if (promises && promises.length > 0) {
      const toastId = toast.loading("Start downing result images...");
      Promise.all(promises)
        .then(() => {
          zip
            .generateAsync({
              type: "blob",
              compression: "DEFLATE", // STORE：默认不压缩 DEFLATE：需要压缩
              compressionOptions: {
                level: 4, // 压缩等级1~9    1压缩速度最快，9最优压缩方式
              },
            })
            .then((res) => {
              toast.success("Download project files started successfully!");
              FileSaver.saveAs(res, projectData?.name || "project.zip");
            })
            .catch((err) => {
              toast.dismiss(toastId);
            });

          toast.dismiss(toastId);
        })
        .catch((err) => console.log("download failed!"));
    } else {
      toast.error("No available result files!");
    }
  };

  const getFile = (url) => {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return (
    <SuiBox>
      <UnionwearLayout>
        <SuiBox display="flex" justifyContent="space-between" alignItems="center" gap={1} py={2}>
          <SuiButton
            onClick={() => {
              navigate(-1);
            }}
            variant={"text"}
            color="dark"
          >
            <ArrowBackIcon sx={{ mr: 0.5, width: 18, height: 18 }} />
            Back
          </SuiButton>
          <SuiTypography variant="h5" color="dark" sx={{ fontSize: { xs: 14, sm: 16, md: 18 } }}>
            {projectData?.name || "Untitled"}
          </SuiTypography>
          <SuiBox display="flex" alignItems="center">
            <SuiButton
              onClick={(e) => {
                e.preventDefault();
                setAllVisibleToggle(!allVisibleToggle);
              }}
              color="info"
              sx={{
                padding: "0px 12px",
                fontSize: 12,
                lineHeight: 0,
                margin: "0px 4px",
                minHeight: 24,
                minWidth: 100,
                textTransform: "none",
                borderRadius: "4px",
              }}
              size="small"
            >
              {allVisibleToggle ? "Hide Finished" : "Show All"}
            </SuiButton>

            <SuiButton
              onClick={(e) => {
                e.preventDefault();
                handleDownloadUrls(images);
              }}
              variant={"text"}
              color="dark"
              sx={{
                textTransform: "capitalize",
              }}
              component={"a"}
              href={"#"}
              download
            >
              <DownloadIcon />
              Download All
            </SuiButton>
            {projectData?.metadata?.selected_images ? (
              <SuiButton
                onClick={(e) => {
                  e.preventDefault();

                  let images = Object.values(projectData?.metadata?.selected_images);
                  if (images.length > 0) {
                    handleDownloadUrls(images);
                  }
                }}
                variant={"text"}
                color="dark"
                sx={{
                  textTransform: "capitalize",
                }}
                component={"a"}
                href={"#"}
                download
              >
                <DownloadIcon />
                Download Selected
              </SuiButton>
            ) : null}
          </SuiBox>
        </SuiBox>

        <SuiBox mb={1} height="100%">
          {productData.map((product) => (
            <ProjectResultItem
              product={product}
              projectData={projectData}
              setProjectData={setProjectData}
              allVisibleToggle={allVisibleToggle}
              handleDownloadUrls={handleDownloadUrls}
            />
          ))}
        </SuiBox>
      </UnionwearLayout>
    </SuiBox>
  );
};

export default ProjectDetailPage;
